import creator from './create';
// 如果页面在快手打开，使用hybrid会导致product强制改成KUAISHOU，只能用browser
export default creator;
